<template>
  <newspaper-form
    :data="props"
    @document-input="props.file_raw = arguments[0]"
    @avatar-file="props.image_raw = arguments[0]"
    @submit="submitForm"
    @update:slug="onSlugChange"
  />
</template>

<script>
import newspaperMixin from "@/components/newspaper/newspaper-mixin"
export default {
  mixins: [newspaperMixin]
}
</script>
